export class ForbiddenError extends Error {
  public code = 403;
  constructor(message?: string) {
    super(message);
    this.name = "ForbiddenError";
  }
}
